export const flaggedFilter = "MIgFHe";
export default {flaggedFilter};